
import LogoImge from '../../../assets/svg/logo2.svg';

const Logo = () => {
    return <>
        <img src={LogoImge} alt="" />
    </>
}

export default Logo;